import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import {
	Box,
	Button,
	Flex,
	Grid,
	GridItem,
	Select,
	Text,
	useToast
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import {
	GET_FAVORITE_PROPERTIES_IDS,
	GET_PROPERTIES_BY_FILTER,
	GET_USER_DATA,
	SEARCH_PROPERTIES_MARKETPLACE
} from '../../Components/Graphql/Queries';
import RedSwanCard from '../Cards/RedSwanCard';
import { ADD_FAVORITE_PROPERTY, REMOVE_FAVORITE_PROPERTY } from '../Graphql/Mutations';
import { jwtDecode } from 'jwt-decode';


export default function Marketplace() {
	const toast = useToast();
	const [showMessage, setShowMessage] = useState(true);
	const [showFilters, setShowFilters] = useState(true);
	const [cardsPerPage, setCardsPerPage] = useState(12);
	const [page, setPage] = useState(0);
	const [startingIndex, setStartingIndex] = useState(page * cardsPerPage);
	const [totalPages, setTotalPages] = useState(Math.ceil(0));
	//const [loopArray, setLoopArray] = useState(Array.from({ length: totalPages }, (_, index) => index + 1));
	const [loopArray, setLoopArray] = useState(null);
	//const cardData = new Array(100).fill('https://marketplace.redswan.io/file-uploads/thumbs/thumb-file-1676659743430.jpg');
	const [cardData, setCardData] = useState(null);
	const [status, setStatus] = useState(null);
	const [propertyType, setPropertyType] = useState(null);
	const [propertyClass, setPropertyClass] = useState(null);
	const [riskLevel, setRiskLevel] = useState(null);
	const [favoriteProperties, setFavoriteProperties] = useState([]);
	const [userName, setUserName] = useState('');

	// const { loading, error, data } = useQuery(SEARCH_PROPERTIES_MARKETPLACE, {
	// 	variables: {
	// 		location: "US",
	// 	},
	// });
	const [getAllPropertiesQuery, { loading, error, data }] = useLazyQuery(SEARCH_PROPERTIES_MARKETPLACE, { fetchPolicy: 'network-only' });
	const [getFavoritePropertiesQuery, favoritePropertiesResponse] = useLazyQuery(GET_FAVORITE_PROPERTIES_IDS, { fetchPolicy: 'network-only' });
	const [getPropertiesByFilterQuery, getPropertiesByFilter] = useLazyQuery(GET_PROPERTIES_BY_FILTER);
	const [removeFavoriteProperty, removeFavoritePropertyResponse] = useMutation(REMOVE_FAVORITE_PROPERTY);
	const [addFavoritePropertyMutation, favoritePropertyResponse] = useMutation(ADD_FAVORITE_PROPERTY);
	const userData = useQuery(GET_USER_DATA);
	const handleClickShowMessage = () => {
		setShowMessage(!showMessage);
	}

	const handleClickShowFilters = () => {
		setShowFilters(!showFilters);
	}
	const handleResetFilter = () => {
		setStatus("");
		setPropertyType("");
		setPropertyClass("");
		setRiskLevel("");
		fetchData();
	}
	const handelFilterProperties = async () => {
		try {
			// console.log("Data of contact us form", data);
			const getPropertiesByFilterInput = {
				propertyClass: propertyClass == "" ? null : propertyClass,
				propertyType: propertyType == "" ? null : propertyType,
				riskLevel: riskLevel == "" ? null : riskLevel,
				status: status == "" ? null : status,
			};
			// console.log(contactUsInput);
			await getPropertiesByFilterQuery({ variables: getPropertiesByFilterInput });
		}
		catch (error) {
			console.log("Error in getting filter Properties: ", error);
		}
	}

	const handleChangeNoOfCards = (e) => {
		console.log("number of cards: ", e.target.value);
		setCardsPerPage(e.target.value);
		setTotalPages(Math.ceil(data?.searchPropertiesByMarketplace.length / e.target.value))
		setPage(0);
		setStartingIndex(0);
		setLoopArray(Array.from({ length: data?.searchPropertiesByMarketplace.length / e.target.value }, (_, index) => index + 1));
	}

	const handleChangePageNumber = (e, page) => {
		console.log('page change function called', page);
		setPage(page - 1);
		setStartingIndex((page - 1) * cardsPerPage);
		console.log((page - 1) * cardsPerPage);
		console.log((page - 1) * cardsPerPage + parseInt(cardsPerPage))
	}

	const handleAddFavoriteProperty = async (e, propertyId) => {
		e.preventDefault();
		console.log("Add favorite property clicked: ", propertyId);

		const addFavoritePropertyInput = {
			propertyId: propertyId
		};
		await addFavoritePropertyMutation({ variables: { addFavoritePropertyInput: addFavoritePropertyInput } });
	}

	const handleRemoveFavoriteProperty = async (e, propertyId) => {
		e.preventDefault();
		console.log("Remove favorite property clicked: ", propertyId);

		const removeFavoritePropertyInput = {
			propertyId: propertyId
		};
		await removeFavoriteProperty({ variables: { removeFavoritePropertyInput: removeFavoritePropertyInput } });
	}

	const fetchData = async () => {
		console.log("Fetch data called");
		await getFavoritePropertiesQuery();
		await getAllPropertiesQuery({
			variables: {
				location: "US",
			}
		});
	}

	useEffect(() => {
		fetchData();
	}, []);

	useEffect(() => {
		if (userData.data !== undefined) {
			setUserName(userData.data.getUserData.firstName);
		}
	}, [userData.loading, userData.data, userData.error]);

	useEffect(() => {
		if (removeFavoritePropertyResponse.data !== undefined) {
			console.log("Response from removing favorite property", removeFavoritePropertyResponse.data);
			toast({
				title: 'Removed from Favorites',
				description: 'Property has been removed from your Favorites',
				status: 'success',
				duration: 4000,
				isClosable: true,
				position: 'bottom-left'
			});
			fetchData();
		}

		if (removeFavoritePropertyResponse.error !== undefined) {
			console.log("Error from removing favorite property: ", removeFavoritePropertyResponse.error);
		}
	}, [
		removeFavoritePropertyResponse.loading,
		removeFavoritePropertyResponse.data,
		removeFavoritePropertyResponse.error
	])

	useEffect(() => {
		if (favoritePropertiesResponse.data !== undefined) {
			console.log("Data from favorite properties: ", favoritePropertiesResponse.data);
			setFavoriteProperties(favoritePropertiesResponse?.data?.getFavoriteProperties?.properties);;
		}

		if (favoritePropertiesResponse.error !== undefined) {
			console.log("Error from favorite properties: ", favoritePropertiesResponse.error);
			// toast({
			// 	title: 'Error',
			// 	description: 'Error in removing property from Favorites',
			// 	status: 'error',
			// 	duration: 4000,
			// 	isClosable: true,
			// 	position: 'bottom-left'
			// });
		}
	}, [
		favoritePropertiesResponse.loading,
		favoritePropertiesResponse.error,
		favoritePropertiesResponse.data
	]);

	useEffect(() => {
		if (favoritePropertyResponse.data !== undefined) {
			console.log("Favorite property response: ", favoritePropertyResponse.data);
			toast({
				title: 'Added to Favorites',
				description: 'Property has been added to your Favorites',
				status: 'success',
				duration: 4000,
				isClosable: true,
				position: 'bottom-left'
			});
			fetchData();
		}

		if (favoritePropertyResponse.error !== undefined) {
			console.log("Favorite property error: ", favoritePropertyResponse.error);
			toast({
				title: 'Error',
				description: 'Error in adding property to Favorites',
				status: 'error',
				duration: 4000,
				isClosable: true,
				position: 'bottom-left'
			});
		}

	}, [
		favoritePropertyResponse.loading,
		favoritePropertyResponse.data,
		favoritePropertyResponse.error
	]);

	useEffect(() => {

		console.log("error:", error)
		console.log("loading:", loading)
		console.log("data:", data)

		if (data != undefined) {
			console.log("data of properties: ", data.searchPropertiesByMarketplace.length);
			setCardData(data.searchPropertiesByMarketplace);
			setTotalPages(Math.ceil(data.searchPropertiesByMarketplace.length / cardsPerPage));
			setLoopArray(Array.from({ length: Math.ceil(data.searchPropertiesByMarketplace.length / cardsPerPage) }, (_, index) => index + 1));
			console.log("total pages", Math.ceil(data.searchPropertiesByMarketplace.length / cardsPerPage));

		}
		if (error != undefined) {
			toast({
				title: 'error',
				description: error.message,
				status: 'error',
				duration: 4000,
				isClosable: true
			});
		}
	}, [data, loading, error]);

	useEffect(() => {

		console.log("error in filter properties:", getPropertiesByFilter.error)
		console.log("loading filter properties:", getPropertiesByFilter.loading)
		console.log("data of filter properties:", getPropertiesByFilter.data)

		if (getPropertiesByFilter.data != undefined) {
			console.log("data of filterProperties: ", getPropertiesByFilter.data);
			setCardData(getPropertiesByFilter.data.getPropertiesByFilter);
			setTotalPages(Math.ceil(getPropertiesByFilter.data.getPropertiesByFilter.length / cardsPerPage));
			setLoopArray(Array.from({ length: Math.ceil(getPropertiesByFilter.data.getPropertiesByFilter.length / cardsPerPage) }, (_, index) => index + 1));
		}
		if (getPropertiesByFilter.error != undefined) {
			toast({
				title: 'error',
				description: getPropertiesByFilter.error.message,
				status: 'error',
				duration: 4000,
				isClosable: true
			});
		}
	}, [getPropertiesByFilter.data, getPropertiesByFilter.loading, getPropertiesByFilter.error]);

	return (
		<>
			<Box bgColor='#F7F9FD' color='#315B84' padding='30px 50px 10px' margin='30px 10px 40px 10px'>
				{/* {console.log("filter status:", status)}
				{console.log("filter propertyType:", propertyType)}
				{console.log("filter propertyClass:", propertyClass)}
				{console.log("filter riskLevel:", riskLevel)} */}

				<Flex justifyContent='space-between'>
					<Text fontSize={'32px'}>
						Welcome {userName},
					</Text>
					{showMessage ? (
						<Text fontSize='13px' cursor='pointer' onClick={handleClickShowMessage}>
							<ChevronUpIcon /> Hide message
						</Text>
					) : (
						<Text fontSize='13px' cursor='pointer' onClick={handleClickShowMessage}>
							<ChevronDownIcon /> Show
						</Text>
					)}
				</Flex>
				{showMessage ? (
					<Box mt='12px' mb='14px'>
						<Text fontSize='14px'>
							As an Asset Tokenization CRE Member, you can explore & invest in our investment opportunities, read our helpful documentation, review our proprietary content that helps in doing your due diligence. If you have any questions about our investment opportunities, please contact the sales agent via email located below each property.
						</Text>
						<Text fontSize='14px'>
							* = Targeted returns are subject to change.
						</Text>
					</Box>
				) : null}
			</Box>
			<Flex justifyContent='space-between' color='#1C3E64' alignItems='center' p='0px 10px'>
				<Flex fontSize={{ base: '10px', sm: '14px' }} gap='5px' flexDirection='row' w='100%'>
					<Text>Show me</Text>
					<select value={cardsPerPage} style={{ background: 'none' }} onChange={handleChangeNoOfCards}>
						<option value={12}>12 items</option>
						<option value={24}>24 items</option>
					</select>
					<Text>per page</Text>
				</Flex>
				<Flex gap='0px'>
					<Button
						onClick={handleResetFilter}
						bg='none'
						border='none'
						fontSize={{ base: '10px', sm: '14px' }}
						_hover={{
							bg: 'none',
							border: 'none'
						}}
					>
						Reset Filter
					</Button>
					{showFilters ? (
						<Button
							bg='none'
							border='none'
							fontSize={{ base: '10px', sm: '14px' }}
							_hover={{
								bg: 'none',
								border: 'none'
							}}
							onClick={handleClickShowFilters}
						>
							<ChevronUpIcon /> Hide Filters
						</Button>
					) : (
						<Button
							bg='none'
							border='none'
							fontSize={{ base: '10px', sm: '14px' }}
							_hover={{
								bg: 'none',
								border: 'none'
							}}
							onClick={handleClickShowFilters}
						>
							<ChevronDownIcon /> Show Filters
						</Button>
					)}
				</Flex>
			</Flex>
			{showFilters ? (
				<Grid
					gap={{ base: '5px', md: '10px' }}
					templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(5, 1fr)' }}
					p='0px 10px'
				>
					<GridItem>
						<Select value={status} onChange={(e) => setStatus(e.target.value)} borderRadius='30px' icon='none' placeholder='Status'>
							<option value="coming soon">Coming Soon</option>
							<option value="express interest">Express Interest</option>
							<option value="live sale">Live Sale</option>
							<option value="closing">Closing</option>
							<option value="closed">Closed</option>
						</Select>
					</GridItem>
					<GridItem>
						<Select value={propertyType} onChange={(e) => setPropertyType(e.target.value)} borderRadius='30px' icon='none' placeholder='Property Type'>
							<option value="Apartments">Apartments</option>
							<option value="Office" >Office</option>
							<option value="Retail">Retail</option>
							<option value="Hospitality">Hospitality</option>
							<option value="Industrial">Industrial</option>
							<option value="MixedUse">Mixed Use</option>
							<option value="Condominium">Condominium</option>
						</Select>
					</GridItem>
					<GridItem>
						<Select value={propertyClass} onChange={(e) => setPropertyClass(e.target.value)} borderRadius='30px' icon='none' placeholder='Property Class'>
							<option value="A">A</option>
							<option value="B">B</option>
							<option value="C">C</option>
							<option value="Mixed">Mixed</option>
						</Select>
					</GridItem>
					<GridItem>
						<Select value={riskLevel} onChange={(e) => setRiskLevel(e.target.value)} borderRadius='30px' icon='none' placeholder='Risk Level'>
							<option value="low">Low</option>
							<option value="medium">Medium</option>
							<option value="high">High</option>
						</Select>
					</GridItem>
					<GridItem>
						<Button
							onClick={handelFilterProperties}
							fontSize='14px'
							bgColor='#002B5B'
							borderRadius='30px'
							color='white'
							padding='6px 12px'
							w='100%'
							fontWeight='300'
							_hover={{
								bgColor: '#1C3E64'
							}}
						>
							Search
						</Button>
					</GridItem>
				</Grid>
			) : null}
			<Flex minH="300px" p={8} flex={1} align={'center'} justify={'center'}>
				{/* { */}
				{/* // loading || getPropertiesByFilter.loading ? <Spinner color="#0a58ca" size="xl" /> : */}
				{cardData?.length==0 ? <Text> No Property to Display</Text> :
					<Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={10}>
						{cardData?.slice(startingIndex, startingIndex + parseInt(cardsPerPage)).map((data, index) => (
							<GridItem key={index} w='100%'>
								<RedSwanCard
									data={data}
									handleAddFavoriteProperty={handleAddFavoriteProperty}
									handleRemoveFavoriteProperty={handleRemoveFavoriteProperty}
									favoriteProperties={favoriteProperties}
								/>
							</GridItem>
						))}
					</Grid>
				}

				{/* } */}

			</Flex>
			<Flex marginTop='20px' justifyContent='center' gap='10px' alignItems='center'>
				{loopArray?.length > 1 &&
					loopArray?.map((iteration) => (
						<Box
							key={iteration}
							bgColor={page + 1 === iteration ? '#002B5B' : '#ECECEC'}
							p='1px 7px'
							cursor='pointer'
							color={page + 1 === iteration ? 'white' : 'black'}
							onClick={(e) => handleChangePageNumber(e, iteration)}
						>
							{iteration}
						</Box>
					))}
			</Flex>
			<Text fontSize='14px' fontStyle='italic' textAlign='center' color='#1C3E64' m='0px 10px'>
				<strong>Disclaimer : </strong>The following properties are not for sale and expression of interest is not a confirmation for immediate investment. Asset Tokenization CRE is targeting several projects for membership investment. Once we have a collective value of interest, we will begin to engage in discussion with property ownership.
			</Text>
		</>
	);
}